import request from '@services/request';

const getCommissionsPaid = async (correspondentId, dateFrom, dateTo) => {
  const params = {
    date_from: dateFrom,
    date_to: dateTo,
  };
  const result = await request.get(`/api/v1/corresponsal/commissions/paid/${correspondentId}`, params);
  const { data } = result;
  return data;
};

const getCommissionsPaidDetail = async (correspondentId, dateFrom, dateTo) => {
  const params = {
    date_from: dateFrom,
    date_to: dateTo,
  };
  const result = await request.get(
    `/api/v1/corresponsal/commissions/paid/${correspondentId}/detail`,
    params
  );
  const { data } = result;
  return data;
};

const getCommissionsToPay = async (correspondentId, dateFrom, dateTo) => {
  const params = {
    date_from: dateFrom,
    date_to: dateTo,
  };
  const result = await request.get(
    `/api/v1/corresponsal/commissions/toPay/${correspondentId}`,
    params
  );
  const { data } = result;
  return data;
};

const getCommissionsToPayDetail = async (correspondentId, dateFrom, dateTo) => {
  const params = {
    date_from: dateFrom,
    date_to: dateTo,
  };
  const result = await request.get(
    `/api/v1/corresponsal/commissions/toPay/${correspondentId}/detail`,
    params
  );
  const { data } = result;
  return data;
};

const getTransactionCommissionReport = async (search = {}) => {
  const result = await request.get('/api/v1/corresponsal/reports/transactions/commissions', search);
  return result;
};

export {
  getCommissionsPaid,
  getCommissionsPaidDetail,
  getCommissionsToPay,
  getCommissionsToPayDetail,
  getTransactionCommissionReport,
};
